import * as t from 'io-ts';
import { BaseEntityNullable, BaseEntityNullableDTO, BaseEntityNullableType } from '../../Global/models/baseEntityNullable';

export const ParticipantItemsGroupType = t.interface({
    item: BaseEntityNullableType,
    additionalItems: t.union([t.array(BaseEntityNullableType), t.null, t.undefined]),
});

export interface ParticipantItemsGroupDto extends t.TypeOf<typeof ParticipantItemsGroupType> {
}

class ParticipantItemsGroup {
    item: BaseEntityNullable;
    additionalItems: BaseEntityNullable[];

    constructor(params: ParticipantItemsGroupDto) {
        this.item            = new BaseEntityNullable(params.item);
        this.additionalItems = params.additionalItems
            ? params.additionalItems.map((item: BaseEntityNullableDTO) => new BaseEntityNullable(item))
            : [];
    }
}

export default ParticipantItemsGroup;
